var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExternalPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-external-people_svg__clip0_3159_37454)",
    stroke: "#2F19B3",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.05 2.365l1.762 2.35h-5.875M17.05 7.066l1.762-2.35",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.537 3.54a2.35 2.35 0 104.7 0 2.35 2.35 0 00-4.7 0zM5.888 6.475a4.7 4.7 0 00-4.7 4.7v1.762a1.175 1.175 0 001.174 1.175h1.175v3.525a1.175 1.175 0 001.176 1.175h2.35a1.175 1.175 0 001.175-1.175v-3.525h1.175a1.175 1.175 0 001.175-1.175v-1.762a4.7 4.7 0 00-4.7-4.7z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-external-people_svg__clip0_3159_37454"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgIconExternalPeople;